
export const companyName = 'Particle Design';

const socialMedia = [
  {
    platform: 'LinkedIn',
    url: 'https://www.linkedin.com/company/18343156/',
  },
  {
    platform: 'Medium',
    url: 'https://medium.com/particle-matter',
  },
  {
    platform: 'Twitter',
    url: 'https://twitter.com/ParticleDesign_',
  },
  {
    platform: 'Instagram',
    url: 'https://www.instagram.com/particle.design/',
  },
];

export const address = {
  line1: '217 NE 8th Ave.',
  line2: '#201',
  city: 'Portland',
  state: 'OR',
  zip: 97232,
  address1: '217 NE 8th Ave. #201',
  address2: 'Portland, OR 97232',
  latitude: 45.5246273,
  longitude: -122.6600956,
};

export const phone = '+1.503.206.7760';

export const email = 'hello@particledesign.com';

export default { socialMedia, address, email, phone };



// WEBPACK FOOTER //
// ./src/data/snippets/companyInfo.js